var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('mx-modal',{attrs:{"value":true,"title":_vm.title,"loading":_vm.loading,"max-width":_vm.maxWidth},on:{"input":function($event){return _vm.$emit('close')}}},[_c('div',{staticClass:"text-align-center"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }